<template>
  <b-container fluid>
    <div v-if="isLoading" class="d-flex justify-content-center p-4 m-3">
      <b-spinner label="Loading..." variant="dark" />
    </div>
    <b-row v-else class="justify-content-md-center">
      <b-col lg="8">
        <base-bread-crumb :items="breadcrumbs" />

        <!-- LU Title -->
        <div class="h5 display-4 font-weight-bold mb-3 header__lu-title">
          {{ learningUnit ? learningUnit.name : '' }}
        </div>

        <!-- Button "Back To previous page" -->
        <div class="mb-3">
          <b-button
            variant="outline-primary"
            class="mb-4 btn__previous-page"
            @click="gotoPreviousPage()"
          >
            <span class="btn-wrapper--icon">
              <font-awesome-icon icon="arrow-left" />
            </span>
            <span class="btn-wrapper--label"> Back to previous page</span>
          </b-button>
        </div>

        <!-- Create submission wording -->
        <p class="font-weight-bold mb-4">Create submission</p>

        <!-- Post/Response -->
        <b-row>
          <b-col cols="12">
            <CardResponse
              :post="post"
              :learner="user"
              :date="new Date(section.start_at)"
              :is-show-full-content="true"
              :post-schedule="postSchedule"
              :active-hide-content-wrapper="false"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CardResponse from './components/CardResponse.vue';
import BaseBreadCrumb from '@/components/base-components/BaseBreadCrumb';

import {
  LearningUnit,
  LearningOutcome,
  Section,
  Post,
  PostResponse,
  Status,
  User,
  PostSchedule
} from '@/models';

export default {
  name: 'PageLearnerSubmission',

  components: {
    FontAwesomeIcon,
    CardResponse,
    BaseBreadCrumb
  },

  data: () => ({
    isLoading: true,
    isFetched: false,
    status: null
    // postResponseIds: [],
  }),

  computed: {
    params() {
      const { learningUnitId, sectionId, postId } = this.$route.params;

      return {
        learningUnitId: Number.parseInt(learningUnitId),
        sectionId: Number.parseInt(sectionId),
        postId: Number.parseInt(postId)
      };
    },

    breadcrumbs() {
      const { name: learningUnitName = '', id: learningUnitId = null } = this.learningUnit,
        { id: sectionId = null } = this.section,
        { title: postTitle = '' } = this.post;

      return [
        {
          key: 'user-dashboard',
          name: 'User Dashboard',
          to: {
            name: 'user-dashboard'
          }
        },
        {
          key: 'micro-credentials-detail',
          name: learningUnitName,
          to: {
            name: 'micro-credentials/detail',
            params: {
              learningUnitId
            }
          }
        },
        {
          key: 'learning-unit-feed',
          name: 'Learning',
          to: {
            name: 'learning-unit/feed',
            params: {
              learningUnitId,
              sectionId
            }
          }
        },
        {
          key: 'submission',
          name: postTitle,
          active: true
        }
      ];
    },

    user() {
      return User.query().first();
    },

    learningUnit() {
      return LearningUnit.find(this.params.learningUnitId);
    },

    section() {
      return Section.find(this.params.sectionId);
    },

    post() {
      return Post.query()
        .where('id', this.params.postId)
        .with([
          'additional_criterion',
          'learning_outcome',
          'vimeo',
          'assessment_statuses',
          'post_schedules'
        ])
        .first();
    },

    postSchedule() {
      return PostSchedule.query().where('section_id', this.section.id).first();
    }

    // PostResponses() {
    //   return PostResponse.query()
    //     .with(["user", "status", "assessment_evaluations"])
    //     .whereIdIn(this.postResponseIds)
    //     .orderBy("created_at")
    //     .get();
    // },
  },

  mounted() {
    this.fetch();
  },

  // watch: {
  //   user: {
  //     immediate: true,
  //     async handler(user) {
  //       if (user) {
  //         this.isLoading = true;
  //         await this.fetch();
  //         this.isFetched = true;
  //         this.isLoading = false;
  //       }
  //     },
  //   },
  // },

  methods: {
    async fetch() {
      try {
        this.isLoading = true;
        // let postResponePromise;

        PostResponse.deleteAll();

        await Promise.all([
          Status.api().fetch(),
          Section.api().fetchById(this.params.sectionId),
          Post.api().fetchOnePostLearner(this.user.id, this.params.postId)
        ]);

        //post response list
        await LearningOutcome.api().fetchById(this.learningUnit.ultimate_learning_outcome_id);

        // postResponePromise = await PostResponse.api().fetchByLearner(
        //   this.user.id,
        //   this.params.postId
        // );

        // const { data = [] } = postResponePromise.response;

        // this.postResponseIds = map(data, "id");
      } catch (error) {
        console.log('fetch learner submission fail : ', error);
      } finally {
        this.isLoading = false;
      }
    },

    // onSubmitSuccess(postResponseId) {
    //   this.postResponseIds.push(postResponseId);
    // },

    gotoPreviousPage() {
      this.$router.push({
        name: 'learning-unit/feed',
        params: {
          learningUnitId: this.params.learningUnitId,
          sectionId: this.params.sectionId
        },
        query: {
          tab: 'posts'
        }
      });
    }
  }
};
</script>
